import React, { createContext, useContext, useMemo, useState } from "react";
import { IssueDetailPanelTabs } from "./IssueDetailPanelTabType";

type ActiveDetailPanelTabContext = [
  key0: IssueDetailPanelTabs | string,
  key1: (arg0: IssueDetailPanelTabs | string) => void
];

const ActiveDetailPanelTabContext = createContext<ActiveDetailPanelTabContext>([
  IssueDetailPanelTabs.Details,
  () => {},
]);

export const useActiveDetailPanelTab = (): ActiveDetailPanelTabContext => {
  return useContext(ActiveDetailPanelTabContext);
};

export const ActiveDetailPanelTabProvider: React.FC = ({ children }) => {
  const [activeDetailPanelTab, setActiveDetailPanelTab] = useState<
    IssueDetailPanelTabs | string
  >(IssueDetailPanelTabs.Details);

  const value = useMemo<ActiveDetailPanelTabContext>(
    () => [activeDetailPanelTab, setActiveDetailPanelTab],
    [activeDetailPanelTab]
  );

  return (
    <ActiveDetailPanelTabContext.Provider value={value}>
      {children}
    </ActiveDetailPanelTabContext.Provider>
  );
};
